import TableMessage from '../message/TableMessage';
import './TableLoading.scss';

const TableLoading = () => {
  return (
    <>
      <tr className='table-loading'>
        <td className='td'></td>
      </tr>
      <tr className='table-loading'>
        <td className='td'></td>
      </tr>
      <tr className='table-loading'>
        <td className='td'></td>
      </tr>
    </>
  );
};

export default TableLoading;
